<template lang="pug">
ValidationObserver(ref='form' v-slot='{ handleSubmit, invalid }')
  .bulk-send-page
    bulk-send-step-bar(:step='3')
    .row
      .col-12.col-sm-8
        form(@submit.prevent='handleSubmit(submit)')
          .col-12.mt-4
            .card.card--rounded
              .card-body.p-4
                form.form
                  h5.title.mb-4(
                    v-html='$t("configureBulkSend.reviewAndSend.title")'
                  )
                  .row
                    .col-12.col-sm-6
                      ValidationProvider(
                        :name='$t("configureBulkSend.reviewAndSend.name")'
                        rules='required'
                        v-slot='{ errors }'
                      )
                        .form-group
                          label.review-label {{ $t('configureBulkSend.reviewAndSend.name') }}
                          .form-control-icon
                            icon(name='file')
                            input#subject.form-control(
                              :class='{ "border-danger": remainingCaracters.title === 0 }'
                              :placeholder='$t("configureBulkSend.reviewAndSend.namePlaceholder")'
                              autocomplete='off'
                              maxlength='60'
                              type='text'
                              v-model='title'
                            )
                            max-text-counter(
                              :limit='60'
                              :value='title'
                              @remaining='remainingCaracters.title = $event'
                            )
                          small.text.text-danger {{ errors[0] }}

                      .form-group(v-if='enableSignatureReminder')
                        label.review-label(for='signature-reminder')
                          | {{ $t('configureBulkSend.reviewAndSend.deadlineForSignReminder') }}
                        select#signature-reminder.form-control(
                          v-model='action_reminder_frequency'
                        )
                          option(:value='null') {{ $t('modal.envelope.review.signatureReminderOptions.select') }}
                          option(value='24') {{ $t('modal.envelope.review.signatureReminderOptions.daily') }}
                          option(value='72') {{ $t('modal.envelope.review.signatureReminderOptions.every3Days') }}
                          option(value='120') {{ $t('modal.envelope.review.signatureReminderOptions.every5Days') }}

                    .col-12.col-sm-6
                      ValidationProvider(
                        name='bulk-send-limit-date'
                        rules='invalidDate'
                        v-slot='{ errors }'
                      )
                        .form-group
                          label.review-label(for='bulk-send-limit-date') {{ $t('configureBulkSend.reviewAndSend.deadlineForSign') }}
                          .form-control-icon
                            icon(name='calendar')
                            date-picker-input#signature-date-limit.form-control(
                              :dateValue='expire_at'
                              :min-date='datePickMinDate'
                              :placeholder='$t("configureBulkSend.reviewAndSend.signatureDeadlinePlaceholder")'
                              @change='validateDate($event, "signature-date-limit")'
                              type='text'
                              v-model='expire_at'
                            )
                          small.text.text-danger {{ errors[0] }}

                  .row
                    .col-12
                      ValidationProvider(
                        name='bulk-send-mail'
                        rules='invalidDate'
                        v-slot='{ errors }'
                      )
                        .form-group
                          label.review-label(for='subject') {{ $t('configureBulkSend.reviewAndSend.subject') }}
                          .form-control-icon
                            icon(name='paper-plane')
                            input#subject.form-control(
                              :class='{ "border-danger": remainingCaracters.subject === 0 }'
                              :placeholder='$t("modal.envelope.review.subjectPlaceholder")'
                              autocomplete='off'
                              maxlength='60'
                              type='text'
                              v-model='subject'
                            )
                            max-text-counter(
                              :limit='60'
                              :value='subject'
                              @remaining='remainingCaracters.subject = $event'
                            )
                    .col-12.mt-1
                      .form-group
                        label.review-label(for='message') {{ $t('configureBulkSend.reviewAndSend.mailMessage') }}
                        textarea#message.form-control(
                          :class='{ "border-danger": remainingCaracters.message === 0 }'
                          :placeholder='$t("modal.envelope.review.messagePlaceholder")'
                          maxlength='500'
                          style='min-height: 120px'
                          v-model='message'
                        )
                        max-text-counter(
                          :limit='500'
                          :value='message'
                          @remaining='remainingCaracters.message = $event'
                        ) 

      .col-12.col-sm-4.mt-4
        .card.card--rounded
          .card-body.p-4
            h5.title.mb-4(
              v-html='$t("configureBulkSend.reviewAndSend.review.title")'
            )
            .row
              .col-12
                p.review-label.review-summary-row
                  strong.text-start {{ $t('model') }}
                  span.text-end {{ template.title }}
                p.review-label.review-summary-row
                  strong.text-start {{ $t('configureBulkSend.reviewAndSend.review.recipientsByEnvelope') }}
                  span.text-end {{ recipientsByEnvelope }}
                p.review-label.review-summary-row
                  strong.text-start {{ $t('configureBulkSend.reviewAndSend.review.totalRecipients') }}
                  span.text-end {{ totalRecipients }} ({{ recipientesInsertionTypeLabel }})
                br
                p.review-label.review-summary-row
                  strong.text-start.review-summary-label
                    icon.review-summary-icon(
                      name='paper-plane'
                      style='color: #013d52'
                    )
                    span {{ $t('configureBulkSend.reviewAndSend.review.sendings') }}
                  span.text-end {{ totalSends }}
                p.review-label.review-summary-row(v-if='!isPostpaid') 
                  strong.text-start.review-summary-label(
                    :class='{ danger: passCreditsLimit }'
                  )
                    icon.review-summary-icon(
                      :class='{ danger: passCreditsLimit }'
                      name='paper-plane'
                      style='color: #013d52'
                    )
                    span {{ $t('configureBulkSend.reviewAndSend.review.remaining') }}
                  span.text-end {{ creditsRemaining }}
                p.review-label.review-summary-row(v-else)
                  strong.text-start.review-summary-label
                    icon.review-summary-icon(
                      name='paper-plane'
                      style='color: #013d52'
                    )
                    span {{ $t('configureBulkSend.reviewAndSend.review.consumed') }}
                  span.text-end {{ totalSends }}

                .bar
                  div(
                    :class='getBarClass'
                    :style='{ width: creditsBarPercentage + "%" }'
                  )

                p.text.mt-2(style='color: #5c7a84')
                  icon.icon-left(
                    name='circle-exclamation'
                    style='margin-right: 0.25rem'
                  )
                  span {{ $t('configureBulkSend.reviewAndSend.review.info') }}

    .row
      .col-12.mt-4
        .alert.alert-warning.alert-dismissible.fade.show(
          role='alert'
          v-if='passCreditsLimit'
        )
          div(style='display: flex; align-items: center')
            icon.icon-left(name='circle-exclamation')
            span(style='font-weight: bold; margin-right: 10px')
              | {{ $t('configureBulkSend.reviewAndSend.noCredits.title') }}!
            span(
              v-html='$t("configureBulkSend.reviewAndSend.noCredits.message")'
            )
            button.close(
              aria-label='Close'
              data-bs-dismiss='alert'
              type='button'
            )
              span &times
  envelope-bottom-bar.bulk-send-page__bottom-bar(
    :disableButtonNextStep='disabledNextStep || invalid'
    :discardAndClose='false'
    :textButtonNextStep='$t("button.send")'
    @nextStep='next'
    @saveAndClose='saveAndClose'
  )

  warning-save-and-close-bulk-send-modal(
    @discardChanges='discardChanges'
    @saveAndClose='saveAndClose'
    ref='saveAndCloseModal'
  )
    p.mb-0 {{ $t('configureBulkSend.confirmDiscard') }}

  no-credit-modal(@saveAndClose='saveAndClose' ref='noCreditModal')
</template>
<script>
import BulkSendStepBar from '@/ui/organisms/BulkSendStepBar.vue';
import WarningSaveAndCloseBulkSendModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseBulkSend.vue';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import MaxTextCounter from '@/ui/atoms/MaxTextCounter.vue';
import Icon from '@/ui/atoms/Icon.vue';
import DatePickerInput from '@/ui/molecules/DatePickerInput.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import NoCreditModal from '@/modules/business/components/organisms/modals/NoCreditModal.vue';
import alert from '@/modules/account/common/alert';
import BulkSendStatus from '@/enums/BulkSendStatus';

export default {
  name: 'BulkSendReview',
  components: {
    NoCreditModal,
    Icon,
    DatePickerInput,
    MaxTextCounter,
    WarningSaveAndCloseBulkSendModal,
    BulkSendStepBar,
    EnvelopeBottomBar,
  },
  beforeRouteLeave(to, from, next) {
    const isBulkSendTab = to.name === 'business.documents.bulk-send';
    const isThisStep = to.name === 'business.bulk-send.review';
    const isPreviousStep = to.name === 'business.bulk-send.recipients';
    const isBulkSendDashboard =
      to.name === 'business.documents.bulk-send-details';

    if (isBulkSendTab || isThisStep || isPreviousStep || isBulkSendDashboard) {
      next();
      return;
    }
    this.$refs.saveAndCloseModal.$refs.modal.open();
    this.nextRoute = next;
  },
  data() {
    return {
      nextRoute: null,
      hasError: false,
      bulkSendId: null,
      template: {},
      bulkSend: {},
      subject: '',
      title: '',
      expire_at: '',
      action_reminder_frequency: '',
      message: '',
      entries: [],
      fileResult: {},
      subscription: {},
      remainingCaracters: {
        subject: 60,
        message: 500,
        title: 60,
      },
    };
  },
  async created() {
    this.updatePageTitleAndHead();
    this.bulkSendId = this.$route.params.id ?? null;
  },
  mounted() {
    this.subscription = this.$store.state.subscription;
  },
  async beforeMount() {
    await this.fetchBulkSend();
    if (this.hasError) {
      console.error('Error fetching bulk send data');
      return;
    }

    this.entries = this.bulkSend.entries ?? [];
    this.fileResult = this.bulkSend.file_result ?? {};
    this.template = this.bulkSend.envelope;

    this.title = this.template.title ?? '';
    this.expire_at = this.template.expire_at ?? '';
    this.action_reminder_frequency =
      this.template.action_reminder_frequency ?? null;
    this.subject = this.template.subject ?? '';
    this.message = this.template.message ?? '';
  },
  computed: {
    isPostpaid() {
      return this.subscription?.plan?.is_postpaid;
    },
    creditsAvailable() {
      return this.subscription?.plan?.quota?.envelopes?.available ?? 0;
    },
    creditsConsumed() {
      return this.subscription?.plan?.quota?.envelopes?.consumed ?? 0;
    },
    creditsRemaining() {
      return this.creditsAvailable - this.creditsConsumed;
    },
    totalSends() {
      return this.bulkSend?.statistics?.total ?? 0;
    },
    totalRecipients() {
      return this.entries.length > 0
        ? this.totalEntryRecipients
        : this.fileRecipients;
    },
    recipientsByEnvelope() {
      return this.bulkSend?.envelope?.recipients?.length ?? 0;
    },
    fileRecipients() {
      const validRows = this.fileResult?.valid_rows ?? 0;
      return validRows * this.recipientsByEnvelope;
    },
    entryRecipients() {
      return this.entries.flatMap((entry) => entry.data);
    },
    totalEntryRecipients() {
      return this.entryRecipients.length ?? 0;
    },
    recipientesInsertionTypeLabel() {
      return Object.entries(this.fileResult).length > 0
        ? this.$t('configureBulkSend.reviewAndSend.review.csvLabel')
        : this.$t('configureBulkSend.reviewAndSend.review.manualLabel');
    },
    creditsBarPercentage() {
      if (this.isPostpaid) {
        return 1;
      }

      if (this.creditsRemaining <= 0) {
        return 0;
      }

      const percentage = (this.totalSends / this.creditsRemaining) * 100;
      return Math.min(100, Math.max(0, percentage));
    },
    passCreditsLimit() {
      return !this.isPostpaid && this.creditsRemaining < this.totalSends;
    },
    getBarClass() {
      return this.passCreditsLimit ? 'failed' : 'processing';
    },
    disabledNextStep() {
      return (
        this.hasError ||
        this.title === '' ||
        (!this.isPostpaid && this.creditsRemaining < this.totalSends)
      );
    },
    datePickMinDate() {
      return new Date().fp_incr(1);
    },
    enableSignatureReminder() {
      return this.expire_at && this.expire_at !== 'invalidDate';
    },
    getPageTitle() {
      return this.isNew || !this.isEditingDraft
        ? this.$t('newBulkSend')
        : this.$t('editBulkSend');
    },
    isNew() {
      return this.$route.params.isNew === true;
    },
    isEditingDraft() {
      return this.$route.params.editDraftBulkSend === true;
    },
    canSendBulkSend() {
      return (
        this.bulkSend.status === BulkSendStatus.CREATED &&
        this.bulkSend?.sent_start === null
      );
    },
  },
  methods: {
    updatePageTitleAndHead() {
      const pageTitle = this.getPageTitle;
      const self = this;
      this.$store.dispatch('page/setTitle', pageTitle);
      this.$store.dispatch('page/setHead', {
        title: pageTitle,
        action() {
          self.$router.replace({
            name: 'business.bulk-send.recipients',
            params: {
              id: self.$route.params.id,
              isNew: self.$route.params.isNew,
              back: true,
              editDraftBulkSend: true,
            },
          });
        },
      });
    },
    async fetchBulkSend() {
      this.hasError = false;
      this.$loading(true);
      await EnvelopesService.getBulkSend(this.bulkSendId)
        .then((response) => {
          this.bulkSend = response.data;
        })
        .catch((error) => {
          this.hasError = true;
          console.error('Error fetching bulk send:', error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async saveDetails() {
      this.$loading(true);
      const data = {
        ...this.bulkSend,
      };
      data.title = this.title;
      data.subject = this.subject;
      data.action_reminder_frequency = this.action_reminder_frequency;
      if (this.expire_at) {
        data.expire_at = this.expire_at;
      }
      if (this.message) {
        data.message = this.message;
      }
      await EnvelopesService.updateBulkSend(this.bulkSendId, data)
        .then((response) => {
          this.bulkSend = response.data;
        })
        .catch((error) => {
          this.hasError = true;
          console.error('Error updating bulk send:', error);
          if (error.response && error.response.status === 409) {
            this.discardChanges();
          }
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    validateDate(event, inputId) {
      if (event === 'invalidDate') {
        document
          .querySelector(`#${inputId} + .date-input`)
          .classList.add('border-danger');
      } else {
        document
          .querySelector(`#${inputId} + .date-input`)
          .classList.remove('border-danger');
      }
    },
    async sendBulkSend() {
      this.hasError = false;
      this.$loading(true);
      await EnvelopesService.sendBulkSend(this.bulkSendId)
        .then((response) => {
          if (response.status !== 202) {
            throw new Error('Failed to send bulk send');
          }
          this.$store.dispatch('subscription/getSubscription');
          this.alertBulkSendSent();
        })
        .catch((error) => {
          this.hasError = true;
          if (error.response.status === 402) {
            this.$refs.noCreditModal.$refs.modal.open();
          }
          console.error('Error sending bulk send:', error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async alertBulkSendSent() {
      alert.fireAlert(this.$t('configureBulkSend.sentBulkSend.title'), {
        classes: 'alert-success',
        styles:
          'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
        icon: 'circle-check',
      });
      this.$loading(true);
      await this.$router.push(
        `/business/documents/bulk-send/${this.bulkSendId}`
      );
      this.$loading(false);
    },
    next() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }
        if (!this.$store.getters['subscription/hasCredits']) {
          this.$refs.noCreditModal.$refs.modal.open();
          return;
        }

        await this.saveDetails();

        this.$loading(true);
        if (this.canSendBulkSend) {
          await this.sendBulkSend();
        }
        this.$loading(false);
      });
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    async saveAndClose() {
      await this.saveDetails();

      if (this.hasError) {
        return;
      }

      if (this.nextRoute) {
        this.nextRoute();
        return;
      }

      this.$router.push({ name: 'business.documents.bulk-send' });
    },
  },
};
</script>
<style scoped lang="stylus">
.review-summary-row
  display: flex
  justify-content: space-between
  align-items: flex-start
  gap: 1rem

  > strong
    flex: 0 0 auto
    min-width: 0
    color: #013D52
    font-weight: 500
    text-align: start
    overflow-wrap: anywhere

  > span
    flex: 0 1 auto
    min-width: 0
    text-align: end
    overflow-wrap: anywhere

.review-summary-label
  display: inline-flex
  align-items: center
  justify-content: flex-start
  gap: 0.375rem
  white-space: nowrap

.review-summary-icon
  flex-shrink: 0

.bulk-send-page
  display: flex
  flex-direction: column
  min-height: calc(100vh - 240px)

.processing
  --status-color: #01AFEC
  height: 100%
  flex-shrink: 0

.failed
  --status-color: #C0392B
  height: 100%
  flex-shrink: 0

.danger
  color: #C0392B !important

.bar
  display: flex
  gap: 2px
  height: 16px
  border-radius: 8px
  overflow: hidden
  background-color: #E9EEEE
  div
    background-color: var(--status-color)

.bulk-send-page__bottom-bar
  margin-top: auto !important
  padding-top: 1.5rem
  flex-shrink: 0
</style>
